
import { Base } from '../base-component';
import './calculators.component.scss';

export class Calculators extends Base {

	constructor(element: Element) {
		super(element);
	}

	init() {}

	bindEvents() {}

}



// WEBPACK FOOTER //
// ./components/calculators/calculators.component.ts